/**
 * SSLP Stars Canvas — Sternschnuppe Landing Page
 * Renders a static starfield + animated shooting stars on a fixed canvas.
 * Fully self-contained IIFE; attaches nothing to window.
 * Respects prefers-reduced-motion and skips shooting stars on small viewports.
 */
(function () {
  'use strict';

  var canvas = document.getElementById('stars-canvas');
  if (!canvas) return;

  var ctx    = canvas.getContext('2d');
  var stars  = [];
  var meteors = [];

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return window.innerWidth < 480; };

  /* ---- Star field ---- */
  function resize() {
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    generateStars();
  }

  function generateStars() {
    stars = [];
    var count = Math.floor((canvas.width * canvas.height) / 5000);
    for (var i = 0; i < count; i++) {
      stars.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.1 + 0.2,
        a: Math.random() * 0.65 + 0.1
      });
    }
  }

  function drawStars() {
    for (var i = 0; i < stars.length; i++) {
      var s = stars[i];
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,' + s.a + ')';
      ctx.fill();
    }
  }

  /* ---- Shooting stars ---- */
  // Angle 150° in canvas coords: moves down-left
  var ANGLE    = (Math.PI / 180) * 150;
  var COS_A    = Math.cos(ANGLE);
  var SIN_A    = Math.sin(ANGLE);
  var SPEED    = 520;   // px/s
  var TAIL     = 180;   // max tail px
  var FADE_IN  = 0.18;  // fraction of lifetime for fade-in
  var FADE_OUT = 0.28;  // fraction of lifetime for fade-out

  function spawnMeteor() {
    var startX   = canvas.width  * (0.25 + Math.random() * 0.75);
    var startY   = canvas.height * (Math.random() * 0.45);
    var dist     = canvas.width  * (0.18 + Math.random() * 0.18);
    var duration = dist / SPEED;

    meteors.push({
      x0: startX, y0: startY,
      dist: dist,
      duration: duration,
      elapsed: 0,
      width: 1.2 + Math.random() * 0.8
    });
  }

  var nextMeteorIn = 0.8 + Math.random() * 1.2; // first shot within ~1-2 s
  var lastTime = null;

  function loop(ts) {
    requestAnimationFrame(loop);
    var dt = lastTime === null ? 0 : Math.min((ts - lastTime) / 1000, 0.1);
    lastTime = ts;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawStars();

    if (!reducedMotion && !isMobile()) {
      nextMeteorIn -= dt;
      if (nextMeteorIn <= 0) {
        spawnMeteor();
        nextMeteorIn = 7 + Math.random() * 7; // 7–14 s between shots
      }

      meteors = meteors.filter(function (m) {
        m.elapsed += dt;
        var progress = Math.min(m.elapsed / m.duration, 1);

        // Head position
        var hx = m.x0 + COS_A * m.dist * progress;
        var hy = m.y0 + SIN_A * m.dist * progress;

        // Tail start (trails behind head)
        var tailLen = Math.min(TAIL, m.dist * progress);
        var tx = hx - COS_A * tailLen;
        var ty = hy - SIN_A * tailLen;

        // Opacity envelope: fade in → hold → fade out
        var opacity;
        if (progress < FADE_IN) {
          opacity = progress / FADE_IN;
        } else if (progress > 1 - FADE_OUT) {
          opacity = (1 - progress) / FADE_OUT;
        } else {
          opacity = 1;
        }
        opacity *= 0.85;

        // Gradient tail
        var grad = ctx.createLinearGradient(tx, ty, hx, hy);
        grad.addColorStop(0,   'rgba(255,255,255,0)');
        grad.addColorStop(0.6, 'rgba(210,228,255,' + (opacity * 0.55) + ')');
        grad.addColorStop(1,   'rgba(255,255,255,' + opacity + ')');

        ctx.beginPath();
        ctx.moveTo(tx, ty);
        ctx.lineTo(hx, hy);
        ctx.strokeStyle = grad;
        ctx.lineWidth   = m.width;
        ctx.lineCap     = 'round';
        ctx.stroke();

        // Small bright glow at head
        var glow = ctx.createRadialGradient(hx, hy, 0, hx, hy, 3.5);
        glow.addColorStop(0, 'rgba(255,255,255,' + (opacity * 1.4) + ')');
        glow.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.beginPath();
        ctx.arc(hx, hy, 3.5, 0, Math.PI * 2);
        ctx.fillStyle = glow;
        ctx.fill();

        return progress < 1;
      });
    }
  }

  resize();
  requestAnimationFrame(loop);
  window.addEventListener('resize', resize, { passive: true });

})();
